import axios from 'axios'

const state = {
  cart: []
}

const actions = {

}


const getters = {
  cart: state => state.cart,
}

const mutations = {
  addToCart(state, article) {
    let alreadyAexist = false
    state.cart.forEach(aArticle => {
      if (aArticle.id == article.id) {
        aArticle.quantite = parseInt(aArticle.quantite) + 1
        alreadyAexist = true
      }
    });
    if (!alreadyAexist) {
      article.quantite = 1
      state.cart.push(article)
    }
    localStorage.setItem("cart", JSON.stringify(state.cart))
  },
  setCart(state, cart) {
    state.cart = cart
  },
  setTotalProductPrice(state, product) {
    state.cart[state.cart.indexOf(product)].quantite = product.quantite
    state.cart[state.cart.indexOf(product)].totalProductPrice = (parseInt(product.quantite) * parseFloat(product.prix).toFixed(2)).toFixed(2)
    localStorage.setItem("cart", JSON.stringify(state.cart))
  },
  deleteFromCart(state, product) {
    state.cart.splice(state.cart.indexOf(product), 1)
    localStorage.setItem("cart", JSON.stringify(state.cart))
  },
  clearCart(state) {
    state.cart = []
    localStorage.removeItem('cart')
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}